import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import systemErrorSVG from './assets/system-error.svg'
import messages from './messages'

interface IGlobalSearchErrorStateProps {
  message?: Nullable<string>
}

export const GlobalSearchErrorState = ({
  message,
}: IGlobalSearchErrorStateProps) => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='404'
      imgUrl={systemErrorSVG}
      header={intl.formatMessage(messages.header)}
      content={<Text>{message ?? intl.formatMessage(messages.content)}</Text>}
    />
  )
}
